export const removeBracketsAndHyphens = (inputString: string) => {
  // Regular expression to match brackets and hyphens
  const regex = /[()\s-]/g;

  // Replace all occurrences with an empty string
  return inputString.replace(regex, "");
}
